let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9LElu")).then(() => parcelRequire('g8r1P'));